// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__Obmga","logo":"Sidebar_logo__ezioV","menu":"Sidebar_menu__LJkPO","menuItem":"Sidebar_menuItem__jLcd2"};